import Vue from 'vue';
import Rollbar from 'vue-rollbar';

import { rollbarAccessToken } from '@/consts';

const rollbarEnv = process.env.VUE_APP_ROLLBAR_ENV || process.env.NODE_ENV;

Vue.use(Rollbar, {
  accessToken: rollbarAccessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: rollbarEnv === 'staging' || rollbarEnv === 'production',
  source_map_enabled: true,
  environment: rollbarEnv,
  payload: {
    client: {
      javascript: {
        code_version: '1.0',
      },
    },
  },
});
